(function () {
    'use strict';

    angular
        .module('gatewayApp')
        .service("workflowSharedService", function () {
            this.viewFrom = 'ManageBBPSSettings'
        })

        .controller('ManageBBPSSettingsController', ManageBBPSSettingsController);

    ManageBBPSSettingsController.$inject = ['$scope', '$state', 'BBPSSettings', 'GlobalValues', 'workflowSharedService', 'EntityPermissions', 'ScreenLog', 'entityConstants','$timeout'];

    function ManageBBPSSettingsController($scope, $state, BBPSSettings, GlobalValues, workflowSharedService, EntityPermissions, ScreenLog, entityConstants,$timeout) {
        var vm = this;
        vm.globalValues = GlobalValues;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.MANAGE_BBPS_SETTINGS;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.screenLog = ScreenLog;
        workflowSharedService.viewFrom = "ManageBBPSSettings";
        vm.bank = GlobalValues.getBank();
        vm.entityOwnerType = vm.globalValues.getUser().entityOwnerType.shortName;
        vm.clicked = false;
        vm.decimalsForPercent = vm.globalValues.getNumberOfDecimalsForPercent();
        vm.decimalForPaise = vm.globalValues.getNumberOfDecimalsForRateInReports();
        vm.currentAndPreviousDaySettings = true;
		$scope.refresh = refresh;
        vm.permitBBPSSettingsEditEntityAction = EntityPermissions.hasPermission('ManageBBPSSettings.EDIT');
        vm.permitBBPSSettingsViewEntityAction = EntityPermissions.hasPermission('ManageBBPSSettings.VIEW');

        logScreenAccess();

        loadAll();
        function loadAll() {

            if (vm.entityOwnerType == 'Bank') {
                
                vm.bankId = vm.globalValues.getBank().id; 
                if (vm.bankId == null) {
                    vm.bankId = 0;
                }
                BBPSSettings.getBBPSSettings({ "bankId": vm.bankId,"currentAndPreviousDaySettings":vm.currentAndPreviousDaySettings}, function (result) {
                    vm.bbpsSettings = result;
                });
            }
        }

        vm.loadBBPSSetting = function loadBBPSSetting(bank) {
            vm.bankId = 0;
            if(vm.entityOwnerType == 'Bank'){
                vm.bankId = vm.globalValues.getBank().id;
            }
            if (bank != null && bank != undefined) {
                vm.bankId = bank.id;
            }

            BBPSSettings.getBBPSSettings({ "bankId": vm.bankId,"currentAndPreviousDaySettings":vm.currentAndPreviousDaySettings }, function (result) {
                vm.bbpsSettings = result;
                vm.clicked = false;
            });




        }
        function logScreenAccess() {
            ScreenLog.screenLog(vm.screenName, 0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
        }

        $scope.toggle = true;
        function refresh() {
            $scope.toggle = false;
            $scope.refreshFlag = false;
            loadAll();
            if ($scope.toggle == false) {
                $timeout(function() {
                    $scope.toggle = true;
                }, 2000);
                $scope.refreshFlag = false;
            }
        };
    }
})();
